module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_14_1.c866b686.jpeg";